import Component from './Component';
import GameObject from '../GameObject/GameObject';
import { GameObjectEvent } from '../GameObject/GameObjectEvent';
import * as PIXI from 'pixi.js';

export default class Interactable extends Component<
    PIXI.Container,
    GameObject
> {
    /**
     * Store the current pointer target. If this same target triggers a "pointer-up" event then emit
     * the "selected" event.
     */
    public static pointerTargetGameObject: GameObject;

    private addPointerListeners(
        gameObject: GameObject,
        container: PIXI.Container
    ): void {
        container.on('pointerdown', (e: any) => {
            gameObject.emit(GameObjectEvent.POINTER_DOWN);
            e.stopPropagation();
            Interactable.pointerTargetGameObject = gameObject;
        });
        container.on('pointerup', () => {
            gameObject.emit(GameObjectEvent.POINTER_UP);
            if (gameObject === Interactable.pointerTargetGameObject) {
                gameObject.emit(GameObjectEvent.SELECTED);
            }
            Interactable.pointerTargetGameObject = null;
        });
        container.on('pointerover', () => {
            gameObject.emit(GameObjectEvent.POINTER_OVER);
        });
        container.on('pointerout', () => {
            gameObject.emit(GameObjectEvent.POINTER_OUT);
        });
        container.on('pointerupoutside', () => {
            gameObject.emit(GameObjectEvent.POINTER_OUT);
            Interactable.pointerTargetGameObject = null;
        });
    }

    private removePointerListeners(
        gameObject: GameObject,
        container: PIXI.Container
    ): void {
        container.off('pointerdown');
        container.off('pointerup');
        container.off('pointerover');
        container.off('pointerout');
        container.off('pointerupoutside');
    }

    public attach(gameObject: GameObject<PIXI.Container>, params: any): void {
        if (!params) params = {};

        if (params.enabled === undefined) {
            params.enabled = true;
        }

        super.attach(gameObject, params);
    }

    public onAttach(gameObject: GameObject, container: PIXI.Container): void {
        //this.addPointerListeners(gameObject, container);
        //this.enabled = this._enabled;
    }

    public onDetach(gameObject: GameObject, container: PIXI.Container): void {
        this.removePointerListeners(gameObject, container);
    }

    get enabled(): boolean {
        return this.container.interactive;
    }

    set enabled(value: boolean) {
        if (value !== this.container.interactive) {
            if (value) {
                this.addPointerListeners(this.gameObject, this.container);
            } else {
                this.removePointerListeners(this.gameObject, this.container);
            }
        }

        this.container.interactive = value;
    }

    get buttonMode(): boolean {
        return this.container.buttonMode;
    }

    set buttonMode(value: boolean) {
        this.container.buttonMode = value;
    }
}
